import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRunNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.56 0a5.5 5.5 0 00-3.446 1.213L7.426 6.59a.5.5 0 01-.167.089L1.063 8.565A1.5 1.5 0 000 10c0 3.132.428 5.467 1.205 7.328.785 1.881 1.886 3.175 3.06 4.27.593.551 1.178 1.039 1.751 1.517 1.72 1.432 3.334 2.778 4.726 5.507 2.067 5.097 4.72 9.48 8.799 12.573C23.656 44.316 29.055 46 36.368 46c4.273 0 7.11-1.18 8.928-2.914 1.8-1.716 2.414-3.793 2.612-5.234.24-1.737-.698-3.184-1.796-4.053l-7.849-6.212a2.5 2.5 0 01-.833-1.21L31.163 6.45A3.5 3.5 0 0027.824 4h-2.84a3.5 3.5 0 00-2.291.854L21.02 6.3l-1.24-4.6A2.3 2.3 0 0017.561 0zm-1.567 3.552a2.501 2.501 0 011.046-.497l2.33 8.644 5.287-4.577A.5.5 0 0124.983 7h2.841a.5.5 0 01.477.35L30.707 15H25v3h6.65l.944 3H27v3h6.537l1.031 3.277a5.5 5.5 0 001.833 2.662l7.675 6.075c-.328.085-.71.177-1.14.27C41.27 36.64 38.876 37 36 37c-4.008 0-6.532-.907-8.377-2.34-1.89-1.47-3.236-3.615-4.656-6.456-.444-.886-.888-1.83-1.356-2.822-2.34-4.966-5.246-11.132-11.32-17.247zm-8.38 6.153c6.051 5.888 8.832 11.773 11.244 16.878.482 1.02.95 2.01 1.426 2.963 1.455 2.91 3.047 5.577 5.5 7.482C28.282 38.97 31.508 40 36 40c3.124 0 5.73-.39 7.564-.783.349-.075.67-.15.962-.222a5.492 5.492 0 01-1.3 1.92C42.1 41.988 40.078 43 36.368 43c-6.839 0-11.548-1.566-15.014-4.195-3.487-2.645-5.883-6.49-7.855-11.367a1.505 1.505 0 00-.052-.115c-1.705-3.374-3.935-5.223-5.741-6.72-.505-.42-.977-.81-1.396-1.2-.972-.906-1.765-1.862-2.337-3.231-.502-1.202-.864-2.799-.952-5.067z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRunNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRunNormalLarge;
